import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getTrialCountRoute } from '../api/constant';
import { employerTrialCount } from '../constants';

type useGetEmployerTrialCountProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
    id: number | boolean
};

export const useGetEmployerTrialCount = ({
    setAlertText = () => { },
    id,
}: useGetEmployerTrialCountProps) => {
    const { data: trialCount, isFetching: isLoadingTrialCount } =

        useQuery({
            queryKey: [employerTrialCount, id],
            queryFn: () =>
                axiosInstance
                    .get(getTrialCountRoute + '?company_id=' + id)
                    .then((res) => res.data),
            enabled: Boolean(id),
            onError: () => {
                setAlertText(errorMessage);
            },
            refetchOnWindowFocus: false,
        });

    return {
        trialCount,
        isLoadingTrialCount,
    };
};
